import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const handleFooterLinkClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="relative overflow-hidden bg-[#f8fafd] text-slate-800">
      <div className="absolute inset-0">

        <div className="absolute inset-0 bg-gradient-to-b from-white/70 via-white/40 to-white/0" />
        <div className="absolute inset-x-0 bottom-0 h-[13.5rem] sm:h-[16.5rem] md:h-[19rem] lg:h-[20.25rem] opacity-90">
          <svg
            className="h-full w-full sm:hidden"
            viewBox="0 0 375 220"
            preserveAspectRatio="none"
          >
            <defs>
              <linearGradient id="mobileMountainBase" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#1c3660" />
                <stop offset="100%" stopColor="#58769d" />
              </linearGradient>
              <linearGradient id="mobileMountainRidge" x1="0%" y1="12%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#274064" />
                <stop offset="100%" stopColor="#101f35" />
              </linearGradient>
              <linearGradient id="mobileSnow" x1="25%" y1="5%" x2="75%" y2="95%">
                <stop offset="0%" stopColor="#ffffff" stopOpacity="0.95" />
                <stop offset="100%" stopColor="#d7e7ff" stopOpacity="0.85" />
              </linearGradient>
            </defs>

            <path
              d="M0,220 L0,142 L28,156 L74,128 L118,164 L166,110 L210,150 L252,90 L296,138 L340,120 L375,150 L375,220 Z"
              fill="url(#mobileMountainBase)"
            />
            <path
              d="M-10,220 L-10,168 L42,186 L92,156 L132,182 L174,148 L216,176 L258,144 L302,166 L344,152 L375,170 L375,220 Z"
              fill="url(#mobileMountainRidge)"
              opacity="0.9"
            />
            <path
              d="M78,188 L108,148 L142,126 L176,134 L206,120 L238,138 L212,170 L182,160 L150,176 L118,170 Z"
              fill="url(#mobileSnow)"
              opacity="0.88"
            />
            <path
              d="M234,174 L252,150 L278,162 L270,190 L246,186 Z"
              fill="#f0f6ff"
              opacity="0.76"
            />
            <path
              d="M36,198 L58,170 L88,182 L78,210 L42,204 Z"
              fill="#e3efff"
              opacity="0.8"
            />
          </svg>

          <svg
            className="hidden h-full w-full sm:block lg:hidden"
            viewBox="0 0 768 220"
            preserveAspectRatio="none"
          >
            <defs>
              <linearGradient id="tabletMountainBase" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#1b3359" />
                <stop offset="100%" stopColor="#5f79a0" />
              </linearGradient>
              <linearGradient id="tabletMountainRidge" x1="0%" y1="12%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#233b61" />
                <stop offset="100%" stopColor="#101f32" />
              </linearGradient>
              <linearGradient id="tabletMountainRidgeFront" x1="0%" y1="14%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#29456d" />
                <stop offset="100%" stopColor="#112640" />
              </linearGradient>
              <linearGradient id="tabletSnow" x1="18%" y1="0%" x2="82%" y2="100%">
                <stop offset="0%" stopColor="#ffffff" stopOpacity="0.95" />
                <stop offset="100%" stopColor="#d5e6ff" stopOpacity="0.84" />
              </linearGradient>
              <radialGradient id="tabletSnowAccent" cx="48%" cy="36%" r="68%">
                <stop offset="0%" stopColor="#ffffff" stopOpacity="0.94" />
                <stop offset="100%" stopColor="#dce9ff" stopOpacity="0.82" />
              </radialGradient>
            </defs>

            <path
              d="M0,220 L0,154 L36,168 L92,138 L142,170 L200,122 L252,160 L304,104 L360,148 L416,110 L472,154 L528,120 L584,162 L640,134 L696,158 L736,148 L768,170 L768,220 Z"
              fill="url(#tabletMountainBase)"
            />
            <path
              d="M-12,220 L-12,172 L52,188 L112,156 L164,182 L220,148 L276,176 L332,142 L392,168 L452,140 L512,170 L568,146 L624,174 L680,152 L736,176 L768,188 L768,220 Z"
              fill="url(#tabletMountainRidge)"
              opacity="0.94"
            />
            <path
              d="M-12,220 L-12,180 L48,192 L102,160 L154,190 L210,158 L264,188 L320,156 L376,180 L432,154 L488,182 L544,160 L600,188 L656,168 L712,188 L768,176 L768,220 Z"
              fill="url(#tabletMountainRidgeFront)"
              opacity="0.94"
            />
            <path
              d="M188,184 L224,140 L270,118 L314,132 L356,118 L400,140 L440,128 L480,146 L452,176 L408,164 L364,182 L324,170 L284,180 L240,168 Z"
              fill="url(#tabletSnow)"
              opacity="0.9"
            />
            <path
              d="M520,176 L540,150 L566,162 L556,188 L528,184 Z"
              fill="#e8f2ff"
              opacity="0.82"
            />
            <path
              d="M108,194 L132,162 L166,176 L152,204 L116,198 Z"
              fill="url(#tabletSnowAccent)"
              opacity="0.86"
            />
          </svg>

          <svg className="hidden h-full w-full lg:block" viewBox="0 0 1200 220" preserveAspectRatio="none">
            <defs>
              <linearGradient id="mountainBase" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#1c3660" />
                <stop offset="100%" stopColor="#6681a5ff" />
              </linearGradient>
              <linearGradient id="mountainRidge" x1="0%" y1="10%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#273f68" />
                <stop offset="100%" stopColor="#0f1f35" />
              </linearGradient>
              <linearGradient id="mountainRidgeFront" x1="0%" y1="12%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#2e4a79" />
                <stop offset="100%" stopColor="#112540" />
              </linearGradient>
              <linearGradient id="snowPrimary" x1="20%" y1="0%" x2="80%" y2="100%">
                <stop offset="0%" stopColor="#ffffff" stopOpacity="0.96" />
                <stop offset="55%" stopColor="#eef4ff" stopOpacity="0.9" />
                <stop offset="100%" stopColor="#d1e4ff" stopOpacity="0.82" />
              </linearGradient>
              <linearGradient id="snowSecondary" x1="10%" y1="0%" x2="90%" y2="100%">
                <stop offset="0%" stopColor="#f9fbff" stopOpacity="0.95" />
                <stop offset="100%" stopColor="#d6e6ff" stopOpacity="0.82" />
              </linearGradient>
              <linearGradient id="snowGlaze" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#fdfdff" stopOpacity="0.92" />
                <stop offset="100%" stopColor="#cfe1ff" stopOpacity="0.78" />
              </linearGradient>
              <radialGradient id="snowAccent" cx="50%" cy="40%" r="70%">
                <stop offset="0%" stopColor="#ffffff" stopOpacity="0.96" />
                <stop offset="100%" stopColor="#d9e9ff" stopOpacity="0.82" />
              </radialGradient>
            </defs>
            
            <path
              d="M0,220 L0,182 L40,192 L110,136 L190,176 L270,120 L350,188 L430,70 L510,143 L590,30 L670,160 L750,82 L830,200 L910,128 L990,188 L1070,140 L1200,220 Z"
              fill="url(#mountainBase)"
            />
            <path
              d="M-20,220 L-20,170 L60,185 L120,155 L180,194 L240,160 L300,197 L360,176 L420,185 L480,149 L540,160 L600,182 L660,156 L720,194 L780,166 L840,185 L900,165 L960,202 L1020,190 L1080,200 L1140,198 L1140,220 Z"
              fill="url(#mountainRidge)"
              opacity="0.95"
            />
            <path
              d="M-20,220 L-20,170 L60,185 L120,136 L180,194 L240,148 L300,197 L360,176 L420,185 L480,149 L540,160 L600,182 L660,156 L720,194 L780,166 L840,185 L900,165 L960,202 L1020,190 L1080,200 L1140,198 L1140,220 Z"
              fill="url(#mountainRidgeFront)"
              opacity="0.95"
              transform="translate(240,0)"
            />
            <path
              d="M332,186 L380,134 L430,102 L472,78 L516,64 L556,74 L594,62 L634,84 L676,114 L706,144 L686,166 L648,150 L612,166 L570,152 L532,162 L494,178 Z"
              fill="url(#snowPrimary)"
              opacity="0.9"
            />
            <path
              d="M216,198 L254,150 L294,136 L324,150 L304,196 L246,206 Z"
              fill="url(#snowSecondary)"
              opacity="0.88"
            />
            <path
              d="M96,210 L136,166 L178,182 L164,220 L106,216 Z"
              fill="url(#snowAccent)"
              opacity="0.85"
            />
            <path
              d="M782,174 L820,136 L856,148 L842,188 L796,180 Z"
              fill="url(#snowGlaze)"
              opacity="0.86"
            />
            <path
              d="M548,92 L570,70 L594,78 L610,98 L580,112 L556,104 Z"
              fill="url(#snowAccent)"
              opacity="0.78"
            />
            <path
              d="M662,130 L684,108 L708,118 L716,140 L694,152 Z"
              fill="url(#snowGlaze)"
              opacity="0.76"
            />
          </svg>
        </div>
      </div>

      <div className="relative z-10 ">
        <div className="mx-auto flex max-w-7xl flex-col gap-16 px-4 py-6 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">
            <div className="lg:col-span-2">
              <div className="flex items-start gap-5">
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white shadow-[0_20px_45px_-12px_rgba(15,23,42,0.4)]">
                  <img src="/logo.png" alt="PahadiLingo logo" className="h-10 w-10 object-contain" width="40" height="40" />
                </div>
                <div>
                  <h3 className="text-2xl font-semibold tracking-tight text-slate-900">PahadiLingo</h3>
                  <p className="text-xs font-medium uppercase tracking-[0.32em] text-slate-400">Kumaoni Dictionary</p>
                  <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-500">
                    Embracing our Mother Tongue - Kumaoni
                  </p>
                </div>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold uppercase tracking-[0.24em] text-slate-700">Quick Links</h4>
              <ul className="mt-6 space-y-3 text-sm text-slate-600">
                {/* <li>
                  <Link to="/quiz" onClick={handleFooterLinkClick} className="inline-flex items-center gap-2 transition-colors duration-200 hover:text-slate-900">
                    <span className="h-px w-6 bg-slate-400" />
                    Quiz
                  </Link>
                </li> */}
                {/* <li>
                  <Link to="/dictionary" onClick={handleFooterLinkClick} className="inline-flex items-center gap-2 transition-colors duration-200 hover:text-slate-900">
                    <span className="h-px w-6 bg-slate-400" />
                    Dictionary
                  </Link>
                </li> */}
                <li>
                  <Link to="/" onClick={handleFooterLinkClick} className="inline-flex items-center gap-2 transition-colors duration-200 hover:text-slate-900">
                    <span className="h-px w-6 bg-slate-400" />
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/dictionary" onClick={handleFooterLinkClick} className="inline-flex items-center gap-2 transition-colors duration-200 hover:text-slate-900">
                    <span className="h-px w-6 bg-slate-400" />
                    Dictionary
                  </Link>
                </li>
                <li>
                  <Link to="/dictionary/words" onClick={handleFooterLinkClick} className="inline-flex items-center gap-2 transition-colors duration-200 hover:text-slate-900">
                    <span className="h-px w-6 bg-slate-400" />
                    Word Index A-Z
                  </Link>
                </li>
                <li>
                  <div className="inline-flex items-center gap-2 text-slate-500">
                    <span className="h-px w-6 bg-slate-300" />
                    <span className="text-xs uppercase tracking-[0.22em]">Letters:</span>
                    <Link to="/dictionary/words/A" onClick={handleFooterLinkClick} className="hover:text-slate-900">A</Link>
                    <span>•</span>
                    <Link to="/dictionary/words/M" onClick={handleFooterLinkClick} className="hover:text-slate-900">M</Link>
                    <span>•</span>
                    <Link to="/dictionary/words/Z" onClick={handleFooterLinkClick} className="hover:text-slate-900">Z</Link>
                  </div>
                </li>
                <li>
                  <Link to="/about" onClick={handleFooterLinkClick} className="inline-flex items-center gap-2 transition-colors duration-200 hover:text-slate-900">
                    <span className="h-px w-6 bg-slate-400" />
                    About Us
                  </Link>
                </li>
                {/* <li>
                  <Link to="/grammar" onClick={handleFooterLinkClick} className="inline-flex items-center gap-2 transition-colors duration-200 hover:text-slate-900">
                    <span className="h-px w-6 bg-slate-400" />
                    Grammar
                  </Link>
                </li> */}
                {/* <li>
                  <Link to="/literature" onClick={handleFooterLinkClick} className="inline-flex items-center gap-2 transition-colors duration-200 hover:text-slate-900">
                    <span className="h-px w-6 bg-slate-400" />
                    Literature
                  </Link>
                </li> */}

                <li>
                  <Link to="/privacy" onClick={handleFooterLinkClick} className="inline-flex items-center gap-2 transition-colors duration-200 hover:text-slate-900">
                    <span className="h-px w-6 bg-slate-400" />
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/terms" onClick={handleFooterLinkClick} className="inline-flex items-center gap-2 transition-colors duration-200 hover:text-slate-900">
                    <span className="h-px w-6 bg-slate-400" />
                    Terms of Service
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold uppercase tracking-[0.24em] text-slate-700">Contact</h4>
              <ul className="mt-6 space-y-4 text-sm text-slate-600">
              <li className="flex items-center gap-3">
                  <a 
                    href="https://www.instagram.com/kumaoni.bhasha?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 transition-colors duration-200 hover:text-slate-900"
                  >
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-pink-600 shadow-sm ring-1 ring-slate-200">
                      <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                        <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2Zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5a4.25 4.25 0 0 0 4.25 4.25h8.5a4.25 4.25 0 0 0 4.25-4.25v-8.5a4.25 4.25 0 0 0-4.25-4.25h-8.5Zm8.9 1.6a.95.95 0 1 1 0 1.9.95.95 0 0 1 0-1.9ZM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 1.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z" />
                      </svg>
                    </span>
                    @kumaoni.bhasha
                  </a>
                </li>
                <li className="flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-sky-500 shadow-sm ring-1 ring-sky-200">
                    <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.6} d="M3 8l9 4.8L21 8" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.6} d="M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </span>
                  <a href="mailto:kumaonibhasha@gmail.com" className="transition-colors duration-200 hover:text-slate-900">
                    kumaonibhasha@gmail.com
                  </a>
                </li>
                <li className="flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-emerald-500 shadow-sm ring-1 ring-emerald-200">
                    <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.6} d="M12 21c5-3.4 8-7.2 8-11.2a8 8 0 10-16 0c0 4 3 7.8 8 11.2z" />
                      <circle cx="12" cy="10" r="3" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.6} />
                    </svg>
                  </span>
                  Uttarakhand, India
                </li>
              
              </ul>
            </div>
          </div>

          <div className="flex flex-col items-start gap-2 border-t border-slate-200 pt-3 pb-2 text-[0.78rem] uppercase tracking-[0.26em] text-white sm:flex-row sm:items-center sm:justify-end">
            <span className="inline-flex items-center gap-3 rounded-full bg-white/10 px-4 py-1 font-semibold text-white shadow-[0_6px_18px_rgba(15,23,42,0.25)] ring-1 ring-white/20 backdrop-blur-sm">
              <span className="h-1 w-6 rounded-full bg-gradient-to-r from-sky-400 to-emerald-400" />
              PahadiLingo · Community-led project from Uttarakhand.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};
